
import React from 'react';
import { AlertCircle } from 'lucide-react';

export function EditorTips() {
  return (
    <div className="p-4 bg-muted/20 text-sm text-muted-foreground border-t w-full overflow-hidden">
      <details>
        <summary className="font-medium cursor-pointer hover:text-primary mb-2">
          Editor Tips & Information
        </summary>
        <div className="pl-2 space-y-2 mt-2">
          <div className="flex gap-2 items-start">
            <AlertCircle className="h-4 w-4 mt-0.5 text-blue-500 flex-shrink-0" />
            <p>
              <strong>Preview:</strong> The preview shows how your email will look with example data. 
              Variables defined in the Variables tab will be shown with their example values.
            </p>
          </div>
          <div className="flex gap-2 items-start">
            <AlertCircle className="h-4 w-4 mt-0.5 text-blue-500 flex-shrink-0" />
            <p>
              <strong>HTML Editing:</strong> Use HTML tags to structure your email. Basic CSS styles are supported 
              for formatting.
            </p>
          </div>
          <div className="flex gap-2 items-start">
            <AlertCircle className="h-4 w-4 mt-0.5 text-blue-500 flex-shrink-0" />
            <p>
              <strong>System Variables:</strong> Use system-wide variables like <code>{"{{COMPANY_NAME}}"}</code> or <code>{"{{LOGO_URL}}"}</code> in any template.
            </p>
          </div>
          <div className="flex gap-2 items-start">
            <AlertCircle className="h-4 w-4 mt-0.5 text-blue-500 flex-shrink-0" />
            <p>
              <strong>Scheduling:</strong> You can schedule emails to be sent at a future time from the Email Schedule tab.
            </p>
          </div>
        </div>
      </details>
    </div>
  );
}
